<div class="mediabox teaser" *ngIf="data" [class.mediaright]="data.mediaAlignment === 'right'">
    <div class="media" *ngIf="getImageUrl() !== ''">
        <figure *ngIf="data.mediaType === 'image'">
            <da-progressive-image
                [options]="{
                    alt: data.image.altText || data.headline,
                    aspectRatios: [
                        {
                            breakpoint: 768,
                            width: 480,
                            height: 320,
                            akamaiImage: getImageUrl() | imageUrl
                        },
                        {
                            breakpoint: 960,
                            width: 578,
                            height: 385,
                            akamaiImage: getImageUrl() | imageUrl
                        },
                        {
                            breakpoint: 1120,
                            width: 768,
                            height: 512,
                            akamaiImage: getImageUrl() | imageUrl
                        }
                    ]
                }"
                (click)="startVideo()"
            ></da-progressive-image>
        </figure>
        <da-video
            *ngIf="data.mediaType === 'video'"
            [data]="getImageUrl()"
            [options]="{
                overlay: true,
                posterUrl: data.video.$urlPosterTarget,
                altText: data.video.altText,
                posterAltText: data.video.altPosterText,
                aspectRatios: videoImageAspectRatios
            }"
            #videoComponent
        >
        </da-video>
    </div>
    <div class="copy">
        <h3 *ngIf="data.headline && data.headline !== ''" [innerHtml]="data.headline"></h3>
        <div
            class="text"
            *ngIf="data.copytext && data.copytext.value && data.copytext.value !== ''"
            [innerHTML]="data.copytext.value"
        ></div>
        <p *ngIf="data.mediaType === 'video'">
            <button da-button themeType="Secondary" [innerHtml]="'PLAY'" (click)="startVideo()"></button>
        </p>
        <p *ngIf="data.mediaType === 'image' && data.button.url.imageUrl">
            <a
                da-button
                [routerLink]="[data.button.url.imageUrl]"
                [icon]="data.button.text ? '' : 'drg-icon-arrow_level_down'"
                [themeType]="data.button.url.linkType"
                [innerHtml]="data.button.text"
            ></a>
        </p>
    </div>
</div>
